import axios from 'axios';
import {
    GET_APPOINTMENT_COUNT,
    APPOINTMENT_COUNT_ERROR,
    GET_LATEST_APPOINTMENTS,
    LATEST_APPOINTMENTS_ERROR,
    GET_ALL_APPOINTMENTS,
    ALL_APPOINTMENTS_ERROR
} from './types';

// import { setAlert } from './alert';
import { base_url } from './constants';

axios.defaults.baseURL = base_url;


export const getApplicationsCount = () => async dispatch => {
    try {
        const res = await axios.get(`/api/appointments/by_client`);
        console.log(res);

        dispatch({ type: GET_APPOINTMENT_COUNT, payload: res.data });
    } catch (err) {
        dispatch({
            type: APPOINTMENT_COUNT_ERROR,
            payload: { msg: err.response }
        });
    }
}


export const getLastestApplications = () => async dispatch => {
    try {
        const res = await axios.get(`/api/appointments/latest_appointment_by_client`);
        dispatch({ type: GET_LATEST_APPOINTMENTS, payload: res.data });
    } catch (err) {
        dispatch({
            type: LATEST_APPOINTMENTS_ERROR,
            payload: { msg: err.response }
        });
    }
}


export const getAllApplications = () => async dispatch => {
    try {
        const res = await axios.get(`/api/appointments/all_appointment_by_client`);
        console.log(res);
        dispatch({ type: GET_ALL_APPOINTMENTS, payload: res.data });
    } catch (err) {
        dispatch({
            type: ALL_APPOINTMENTS_ERROR,
            payload: { msg: err.response }
        });
    }
}